import * as React from 'react'

import styled, { createGlobalStyle } from 'styled-components'

import { COLORS } from '@ulule/owl-kit-components/next'
import { ErrorBodyWrapper, ErrorPage } from '@owl-nest/error'
import { t } from '@owl-nest/localize'

import * as url from '@boutique/url'

export default function Custom404(): React.ReactElement {
  return (
    <>
      <AppContainerGlobalStyle />
      <StyledErrorPage
        translations={{
          errorName: t('404 - Page not found'),
          title: t('Are you lost?'),
          subtitle: t("It's ok we all are sometimes"),
          link: t('back to home'),
          searchPlaceholder: t('Search a project'),
        }}
        urls={{
          home: url.homepage().path,
        }}
        color={COLORS.PRIMARY_BLUE}
        search={{
          enable: false,
        }}
        bg={{
          video: {
            mp4: 'https://s3-eu-west-1.amazonaws.com/com.ulule.store/video/owl-404.mp4',
            webm: 'https://s3-eu-west-1.amazonaws.com/com.ulule.store/video/owl-404.webm',
          },
          image: 'https://s3-eu-west-1.amazonaws.com/com.ulule.store/video/owl-loop-mobile.gif',
        }}
      />
    </>
  )
}

;(Custom404 as any).Layout = function Layout({ children }: React.PropsWithChildren) {
  return <>{children}</>
}

const StyledErrorPage = styled(ErrorPage)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${ErrorBodyWrapper} {
    flex-grow: 1;
  }
`

const AppContainerGlobalStyle = createGlobalStyle`
  #__next {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }
`
